import api from '../../api'
import {GET_TEAM_REQUEST, GET_TEAM_SUCCESS, GET_TEAM_FAILURE, SET_ACTIVE_TEAM, SEND_ANSWER_SUCCESS} from '../mutation_types'

// Initial state
const state = {
    activeTeam: null,

    // Has the active team run out of time?
    outOfTime: false,

    // Recently played events and team
    recentEvents: localStorage.getItem('recentEvents') ? JSON.parse(localStorage.getItem('recentEvents')) : [],
    recentTeam: null,

    // Select team form state
    error: null,
    loading: false,
    loadingName: null
};

// Getters
const getters = {
    team: state => state.activeTeam,
    visitedQuestions: state => {
        if (!state.activeTeam) {
            return [];
        }

        return state.activeTeam.answers.map(answer => answer.question);
    },
    finished: (state, getters, rootState) => {
        if (!state.activeTeam || !rootState.events.activeEvent) {
            return false
        }
        
        console.log('finished', state.activeTeam.answers.length, rootState.events.activeEvent.points.length)
        return state.outOfTime || state.activeTeam.answers.length === rootState.events.activeEvent.points.length
    }
}

// Actions
const actions = {
    async createTeam({getters, commit}, name) {
        commit(GET_TEAM_REQUEST, name);

        try {
            const team = await api.createTeam(getters.event._id, name);
            commit(GET_TEAM_SUCCESS);
            commit(SET_ACTIVE_TEAM, team);
        } catch (err) {
            commit(GET_TEAM_FAILURE, err);
        }
    },
    async resumeRecentTeam({rootState, commit}) {
        commit(GET_TEAM_REQUEST, rootState.events.recentTeam.name);

        try {
            const team = await api.getTeam(rootState.events.recentTeam._id);
            commit(GET_TEAM_SUCCESS);
            commit(SET_ACTIVE_TEAM, team);
        } catch (err) {
            commit(GET_TEAM_FAILURE, err);
        }
    }
};

// Mutations
const mutations = {
    [GET_TEAM_REQUEST] (state, name) {
        state.error = null;
        state.loading = true;
        state.loadingName = name;
    },

    [GET_TEAM_SUCCESS] (state) {
        state.loading = false;
    },

    [GET_TEAM_FAILURE] (state, error) {
        state.error = error;
        state.loading = false;
    },

    [SET_ACTIVE_TEAM] (state, team) {
        state.activeTeam = team
        state.outOfTime = false
    },

    [SEND_ANSWER_SUCCESS] (state, response) {
        for (let key in response.team) {
            if (response.team.hasOwnProperty(key) && state.activeTeam.hasOwnProperty(key)) {
                state.activeTeam[key] = response.team[key]
            }
        }

        state.activeTeam.answers.push(response.answer)
    },

    OUT_OF_TIME(state) {
        state.outOfTime = true
    },

    EXIT_GAME(state) {
        state.activeTeam = null;
    }
};

// Export
export default {
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/teams.js